import {Injectable} from '@angular/core';
import {WebsiteStatesService} from '../../website-states.service';
import {Observable} from 'rxjs';

declare const responsiveWidths: number[];


@Injectable()
export class ResponsiveStateService {
  constructor(private website: WebsiteStatesService) {
  }

  // noinspection JSMethodCanBeStatic
  get responsiveWidths(): number[] {
    return ((<any>window).responsiveWidths && responsiveWidths || []).sort((a, b) => a - b);
  }

  getWidth(forElement: HTMLElement): Observable<number> {
    return this.website.windowResize.map(() => {
      const width = forElement.clientWidth;

      if (this.responsiveWidths.length === 0) {
        return 0;
      }
      const smallestWidth = this.responsiveWidths[0];

      if (width <= smallestWidth) {
        return smallestWidth;
      }

      // Return next width after width
      return this.responsiveWidths.filter(w => w > width)[0];
    });
  }
}
